import { useState } from "react";
import { useDispatch } from "react-redux";

import * as actions from "../../../actions";
import { Tooltip } from "flowbite-react";
import { Popup } from "../../../components/pop-up";
import { IconButton } from "../../../components/buttons";

export function ToggleCoworkerCompany(props) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState();
  const removeCowrokerCompany = () => {
    dispatch(
      actions.COWORKERCOMPANY_REQ({
        company_uids: [props.data?.company_uid],
        coworker_uid: [props.coworkerDetails?.coworker_uid],
        _isDeleteCompanyForCoworker: true,
      })
    );
  };
  return (
    <>
      <Tooltip content={"Remove Company Access"} placement="bottom">
        <IconButton onClick={() => setOpenModal("pop-up")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </IconButton>
      </Tooltip>
      <Popup
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="stroke-red-600 mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to remove access to{" "}
              <b className="text-red-500">{props?.data?.company_name}</b> for{" "}
              <b>{props?.coworkerDetails?.fullName}</b>?
            </h3>
          </>
        }
        cancelText="No, cancel"
        confirmText="Yes, remove"
        confirmClass="bg-red-600 text-white"
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          removeCowrokerCompany();
          setOpenModal(undefined);
        }}
      />
    </>
  );
}
